import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import Admin from './layouts/admin';
import Login from './components/login/login';
import Register from './components/register/register';
import User from './layouts/user';
import Duppata from './components/views/shop/duppatas/duppata';
import ShirtTrouser from './components/views/shop/shirtTrouser/shirtTrouser';
import Home from './components/views/home/home';
import Gharara from './components/views/bridals/gharara/gharara';
import Lahangas from './components/views/lahangas/lahangas';
import Maxi from './components/views/maxi/maxi';
import Saree from './components/views/saree/saree';
import LandingPage from './pages/landingPage';
import './App.css';
function App() {
  const router = createBrowserRouter([
    {
      element: <Admin />,
      errorElement: <Navigate to="/login" />,
      children:
        [
          {
            path: "/login",
            element: <Login />
          },

          {
            path: "/register",
            element: <Register />
          }
        ]
    },
    {
      element: <User />,
      children:
        [
          // {
          //   path: "/",
          //   element: <Home />
          // },
          {
            path: "/dupatta",
            element: <Duppata />
          },
          {
            path: "/shirtTrouser",
            element: <ShirtTrouser />
          },
          {
            path: "/ghararas",
            element: <Gharara />
          },
          {
            path: "/lahangas",
            element: <Lahangas />
          },
          {
            path: "/saree",
            element: <Saree />
          },
          {
            path: "/maxi",
            element: <Maxi />
          },
          {
            path: "/",
            element: <LandingPage />
          }
        ]
    }
  ])

  return (

    <div className='wrapper'>
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
